import type { FunctionComponent } from 'react';
import get from 'lodash/get';
import { SEASON } from '../../../../constants';
import Product from '../../Product';
import fffBox from './fff-box.png';
import * as styles from './styles.module.scss';

const getBoxName = (seasonCode: string) => {
  const year = seasonCode.substr(0, 2);
  const seasonNum = seasonCode.substr(2, 2);
  const season = get(SEASON, seasonNum, '');
  return `${season} 20${year} Box`;
};

type BoxProps = {
  box: {
    seasonCode: string;
    items: {
      name: string;
      brandName: string;
      title: string;
      imageUrl: string;
      autoAssigned: boolean;
      slug: string;
    }[];
  };
};

const Box: FunctionComponent<BoxProps> = ({ box }) => (
  <div className={styles.box} data-testid="box-container">
    <div className={styles.boxHeader} data-testid="box-header">
      <img src={fffBox} alt="FFF Box" data-testid="box-image" />
      <div className={styles.boxInfo}>
        <h1>{getBoxName(box.seasonCode)}</h1>
        <p className={styles.description}>Up to $300 value (depending on choices)</p>
        <p className={styles.note}>
          Subscription charge is included in your order total where applicable.
        </p>
      </div>
    </div>
    <ul>
      {box.items.map(({ name, brandName, title, imageUrl, autoAssigned, slug }, index) => (
        <Product
          key={index}
          name={name}
          brandName={brandName}
          title={title}
          imageUrl={imageUrl}
          autoAssigned={autoAssigned}
          slug={slug}
        />
      ))}
    </ul>
  </div>
);

export default Box;
